import styled from 'styled-components'

export const CollapsibleCont = styled.div``
